/**
 * @doo-events/design-tokens v2 — modo claro/escuro com switch.
 *
 *   import { getColorMode, setColorMode, applyColorMode } from '@doo-events/design-tokens/color-mode';
 *
 * Decisão (andamento do plano): todos os frontends abrem no CLARO — o padrão da LP — e
 * a pessoa troca pelo switch. A escolha fica no navegador (localStorage). Não segue a
 * preferência do sistema: a mesma tela aparece igual para o time e para o cliente até
 * alguém escolher.
 *
 * O escuro é a classe `.dark` no <html> (semantic/dark.css) — no <html>, e não num
 * contêiner, para dialogs/popovers/toasts (que renderizam em <body>) acompanharem.
 *
 * Anti-flash: cole `COLOR_MODE_BOOT` num <script> no <head> do index.html, ANTES do
 * CSS. Sem ele, quem escolheu o escuro vê um quadro claro enquanto o JS carrega.
 */

export const COLOR_MODE_KEY = 'doo:color-mode';
export const COLOR_MODE_EVENT = 'doo:color-mode';

/** Script de boot (string) para o <head>: liga `.dark` antes do primeiro paint. */
export const COLOR_MODE_BOOT = `try{if(localStorage.getItem('${COLOR_MODE_KEY}')==='dark')document.documentElement.classList.add('dark')}catch(e){}`;

/** A escolha salva, ou 'light' (padrão do design system). */
export function getColorMode() {
  try {
    return localStorage.getItem(COLOR_MODE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

/** Liga/desliga `.dark` no elemento (padrão: <html>) sem salvar nada. */
export function applyColorMode(mode, root = document.documentElement) {
  root.classList.toggle('dark', mode === 'dark');
}

/** Salva a escolha, aplica e avisa quem estiver ouvindo (outros switches na tela). */
export function setColorMode(mode) {
  const valor = mode === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem(COLOR_MODE_KEY, valor);
  } catch {
    // Armazenamento bloqueado: aplica só nesta página.
  }
  applyColorMode(valor);
  window.dispatchEvent(new CustomEvent(COLOR_MODE_EVENT, { detail: valor }));
  return valor;
}

/** Inverte o modo atual. */
export function toggleColorMode() {
  return setColorMode(getColorMode() === 'dark' ? 'light' : 'dark');
}

/** Ouve mudanças (deste e de outras abas). Devolve a função que para de ouvir. */
export function onColorModeChange(callback) {
  const local = (e) => callback(e.detail);
  const outraAba = (e) => {
    if (e.key !== COLOR_MODE_KEY) return;
    const modo = e.newValue === 'dark' ? 'dark' : 'light';
    applyColorMode(modo);
    callback(modo);
  };
  window.addEventListener(COLOR_MODE_EVENT, local);
  window.addEventListener('storage', outraAba);
  return () => {
    window.removeEventListener(COLOR_MODE_EVENT, local);
    window.removeEventListener('storage', outraAba);
  };
}
